import { useMemo } from 'react'
import { DocumentsOpen } from '../../context/GlobalContext'
import { useSettings } from '../useSettings'
import { DEFAULT_DOCUMENTS_OPEN } from '../../helpers/documentHelper'

/**
 * The effective DOCUMENTS_OPEN behavior for the current user: action (OPEN/DOWNLOAD) and target
 * (APP vs. ONLINE) come from the delivered office/user setting, falling back to the default
 * (open in the desktop app) when absent (HAM-4251).
 */
export default function useDocumentsOpen(): DocumentsOpen {
    const { settings } = useSettings()

    return useMemo<DocumentsOpen>(
        () => ({
            action: settings.documentsOpen?.action ?? DEFAULT_DOCUMENTS_OPEN.action,
            target: settings.documentsOpen?.target ?? DEFAULT_DOCUMENTS_OPEN.target,
        }),
        [settings.documentsOpen?.action, settings.documentsOpen?.target],
    )
}
